module.exports = __webpack_public_path__ + "static/media/dz.9740dff8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dz.svg
// module id = 103
// module chunks = 0